import React from "react";
import ContactForm from "../../../Components/FormElements/ContactForm";
import { Input } from "../../../Components/FormElements";


const inputTheme = [
  {
    textColor: "#222",
    backColor: "#fff",
    borderColor: "#e9e9e9",
  }
];
const buttonTheme = [
  {
    textColor: "#fff",
    backColor: "hsl(217, 40%, 35%)",
  }
];
export default class ContactInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSent: false,
      errors: {},
      person: {
        fullname: '',
        from: '',
        country: '',
        subject: '',
        message: '',
      }
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.pushContact = this.pushContact.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
  }

  pushContact(person) {
    let data = null;
    let xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    const slate = this;
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4 && this.status === 200) {
        console.log(`${this.responseText} and status is ${this.status}`);
        slate.setState({isSent: true});
        console.log("is Sent state is ", slate.state.isSent);
      }
    });

    xhr.open("GET", "https://lms.globalgers.co/contact_us.php");
    xhr.setRequestHeader("fullname", person.fullname);
    xhr.setRequestHeader("from", person.from);
    xhr.setRequestHeader("country", person.country);
    xhr.setRequestHeader("subject", person.subject);
    xhr.setRequestHeader("message", person.message);
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(data);    
  }
  handleValidation() {
    let fields = this.state.person;
    let errors = {};
    let formIsValid = true;

  
    if(!fields.fullname) {
      formIsValid = false;
      errors["fullname"] = "Full name cannot be empty";
      console.log('fullname 1 here is ', fields.fullname);
    }
    if(typeof fields.fullname !== undefined || fields.fullname !== '') {
      if(!fields.fullname.match(/^[a-zA-Z]+(?:\s[a-zA-Z]+)?$/)) {
        formIsValid = false;
        errors["fullname"] = "Only characters in fullname please";
        console.log('fullname here is ', fields.fullname);
      }
    }
    if(!fields.message) {
      formIsValid = false;
      errors["message"] = "Message cannot be empty";
      console.log('message here is 1 ', fields.message);
    }
  
    if(!fields.from) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
      console.log('from 1 here is ', fields.from);
    }
    if(typeof fields.from !== "undefined" || fields.from !== '') {
      let lastAtPos = fields.from.lastIndexOf('@');
      let lastDotPos = fields.from.lastIndexOf('.');

      if(!(lastAtPos < lastDotPos && lastAtPos > 0 
        && fields.from.indexOf('@@') === -1 
        && lastDotPos > 2 && (fields.from.length - lastDotPos) > 2)) {
          formIsValid = false;
          errors["from"] = "Email is not valid";
          console.log('from here is ', fields.from);
      }
    }
    this.setState({errors: errors});
    return formIsValid;
  }
  handleInputChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    this.setState(prevState => {
      return {
        person: {...prevState.person, [name]: value }
      }
    }, () => console.log("Person is: ", this.state.person));
    if(this.state.person.fullname.match(/^[a-zA-Z]+(?:\s[a-zA-Z]+)?$/)) {
      document.querySelector('input[name="fullname"]').setAttribute('style', 'color: green');
    }
    else {
      document.querySelector('input[name="fullname"]').setAttribute('style', 'color: red');
    }
  }
  handleFormSubmit(e) {
    e.preventDefault();
    if (this.handleValidation()) {
      this.pushContact(this.state.person);
    }
    else {
      alert("Please address form errors");
    }
  
  }

  render() {
    return (
      <div>
      <ContactForm
        person={this.state.person}
        handleFormSubmit={this.handleFormSubmit}
        handleInputChange={this.handleInputChange}
        inputTheme={inputTheme}
        buttonTheme={buttonTheme}
      />
      { this.state.isSent && <p>{`Thank you, ${this.state.person.fullname}! Your message has been sent.`}</p> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Misc/Components/Input.js